(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBill2Controller', SuperBill2Controller);

    SuperBill2Controller.$inject = ['$scope', '$state', 'SuperBill', 'SuperBillSearch'];

    function SuperBill2Controller ($scope, $state, SuperBill, SuperBillSearch) {
        var vm = this;

        vm.superbills = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Superbill.query(function(result) {
                vm.superbills = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SuperbillSearch.query({query: vm.searchQuery}, function(result) {
                vm.superbills = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
